/** Public class path: /school/:schoolSlug/class/:classSlug */

export function classPublicPath({ schoolSlug, classSlug, public_path } = {}) {
  if (public_path) return public_path;
  const school = String(schoolSlug || "").replace(/^\/+|\/+$/g, "");
  const cls = String(classSlug || "").replace(/^\/+|\/+$/g, "");
  if (!school || !cls) return null;
  return `/school/${school}/class/${cls}`;
}

/** YYYY-MM-DD from an ISO datetime. */
export function classSessionDateKey(iso) {
  if (iso == null || iso === "") return null;
  const s = String(iso);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString().slice(0, 10);
}

/**
 * Build a public class href with optional date / rsvp query.
 * Accepts listing-shaped objects or explicit slug fields.
 */
export function classPublicHref(input = {}, opts = {}) {
  const schoolSlug =
    input.schoolSlug ||
    input.school_slug ||
    input.school?.slug ||
    null;
  const classSlug =
    input.classSlug ||
    input.slug ||
    input.class?.slug ||
    null;
  const path = classPublicPath({
    schoolSlug,
    classSlug,
    public_path: input.public_path || input.class?.public_path,
  });
  if (!path) return null;

  const date =
    opts.date !== undefined
      ? opts.date
      : input.date ||
        classSessionDateKey(
          input.effective_datetime ||
            input.next_instance?.effective_datetime ||
            input.next_instance?.datetime ||
            input.datetime,
        );
  const qs = new URLSearchParams();
  if (date) qs.set("date", String(date));
  if (opts.rsvp) qs.set("rsvp", "1");
  const extra = opts.searchParams;
  if (extra instanceof URLSearchParams) {
    for (const [k, v] of extra.entries()) {
      if (k === "instance" || k === "date" || k === "rsvp") continue;
      qs.set(k, v);
    }
  }
  const q = qs.toString();
  return q ? `${path}?${q}` : path;
}

/** Pick earliest instance matching a YYYY-MM-DD date key. */
export function pickInstanceForDate(instances, dateKey) {
  if (!dateKey || !instances?.length) return null;
  const matches = instances.filter(
    (inst) =>
      classSessionDateKey(inst.effective_datetime || inst.datetime) === String(dateKey),
  );
  if (!matches.length) return null;
  matches.sort((a, b) =>
    String(a.effective_datetime || a.datetime || "").localeCompare(
      String(b.effective_datetime || b.datetime || ""),
    ),
  );
  return matches[0];
}
